import * as E from "../../either";
import { fromValidate, validate } from "../validated";
const rightMerge = (r1) => (r2) => (Object.assign(Object.assign({}, r1), r2));
/**
 * Intersection validators.
 * Merges types with `&`.
 * Result is the combination of validators with priority on right
 */
export function intersection(...args) {
    // `reduce` is not capable of inferring type that would come out of merging
    // all types from array, thus the type cast is needed here
    const [first, ...rest] = args;
    return fromValidate((x) => rest.reduce((e, t) => E.ap(E.map(rightMerge, e), validate(t, x)), validate(first, x)));
}

